import api from '@/api/services/api'

const getCollection = params => api({
  method: 'get',
  url: 'events',
  params
})

const getEvent = id => api({
  method: 'get',
  url: `events/${id}`
})

const create = data => api({
  method: 'post',
  url: 'events',
  data
})

const update = ({ id, data }) => api({
  method: 'put',
  url: `events/${id}`,
  data
})

const remove = id => api({
  method: 'delete',
  url: `events/${id}`,
})

export {
  getCollection,
  getEvent,
  create,
  update,
  remove
}